import React, { useContext } from 'react';
import { DeleteConfirmation, RouterContext } from '../../../../gs-component-right-rail';
import { Values } from '../../../EventTypes';

interface Props {
  values: Values;
  resetForm: () => void;
  onClose: () => void;
}

const DiscardConfirmation: React.FC<Props> = ({ values, resetForm, onClose }) => {
  const { goBack } = useContext(RouterContext);

  const discardForm = (): void => {
    resetForm();
    onClose();
  };

  return (
    <DeleteConfirmation
      onDelete={discardForm}
      onCancel={goBack}
      info="It looks like you haven't saved your changes yet. Would you still like to leave?"
    />
  );
};

export default DiscardConfirmation;
